/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_To_Sovereign_ForInputs */

const en_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Sovereign for`)
};

const es_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiza a Sovereign por`)
};

const fr_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passez à Sovereign pour`)
};

const de_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade auf Sovereign für`)
};

const ja_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereignにアップグレードして`)
};

const zh_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级至 Sovereign 以享受`)
};

const ar_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بالترقية إلى Sovereign مقابل`)
};

const id_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkatkan ke Sovereign untuk`)
};

const it_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Sovereign per le`)
};

const ru_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите на Sovereign, чтобы получить`)
};

const pt_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upgrade para Sovereign por`)
};

const ko_upgrade_to_sovereign_for = /** @type {(inputs: Upgrade_To_Sovereign_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 혜택을 위해 Sovereign으로 업그레이드하세요: 수수료`)
};

/**
* | output |
* | --- |
* | "Upgrade to Sovereign for" |
*
* @param {Upgrade_To_Sovereign_ForInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_to_sovereign_for = /** @type {((inputs?: Upgrade_To_Sovereign_ForInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_To_Sovereign_ForInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_to_sovereign_for(inputs)
	if (locale === "es") return es_upgrade_to_sovereign_for(inputs)
	if (locale === "fr") return fr_upgrade_to_sovereign_for(inputs)
	if (locale === "de") return de_upgrade_to_sovereign_for(inputs)
	if (locale === "ja") return ja_upgrade_to_sovereign_for(inputs)
	if (locale === "zh") return zh_upgrade_to_sovereign_for(inputs)
	if (locale === "ar") return ar_upgrade_to_sovereign_for(inputs)
	if (locale === "id") return id_upgrade_to_sovereign_for(inputs)
	if (locale === "it") return it_upgrade_to_sovereign_for(inputs)
	if (locale === "ru") return ru_upgrade_to_sovereign_for(inputs)
	if (locale === "pt") return pt_upgrade_to_sovereign_for(inputs)
	return ko_upgrade_to_sovereign_for(inputs)
});